module.exports = __webpack_public_path__ + "static/img/icon.a37f95e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_1/icon.jpg
// module id = jGez
// module chunks = 0